import {useParams} from "react-router-dom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import axios from "axios";
import {FOOTER_REPORTS_URL} from "../../service/UrlConstant";
import {trackPromise} from "react-promise-tracker";
import {GridSpinner} from "../../components/Spinner";
import {Document, Page, pdfjs} from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import {Col, Container, Row} from "react-bootstrap";
import useWindowDimensions from "../../hooks/Dimensions";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import * as b64 from 'base64-js'
import {saveAs} from 'file-saver';

export default function FooterReportsPanel() {
    const {fileName} = useParams();
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [reportData, setReportData] = useState(null);
    const [downloadReportData, setDownloadReportData] = useState(null);
    const {isMobile} = useWindowDimensions();
    const [desktopScale, setDesktopScale] = useState(1.0);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);

    const documentRef = useRef();

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`
    }, []);

    useEffect(async () => {
        const params = {
            fileName
        }

        const response = await trackPromise(axios.get(FOOTER_REPORTS_URL, {params}));

        const reportEncoded = response.data.report;

        setReportData(reportEncoded)
        setDownloadReportData(b64.toByteArray(reportEncoded));
    }, [fileName]);

    function PagePREV() {
        return (<>
            {pageNumber > 1 && <a className="linkColor" href="#" aria-disabled={pageNumber === 1} onClick={() => {
                if (pageNumber > 1) {
                    setPageNumber(pageNumber - 1)
                } else {
                    setPageNumber(1)
                }
            }}>
                <i className="td-icon icon-small td-icon-arrowLeft2"></i>
            </a>}
        </>)
    }

    function PageNext() {
        return (<>
            {pageNumber < numPages && <a className="linkColor" href="#" aria-disabled={pageNumber === numPages}
                                         onClick={() => {
                                             if (numPages > pageNumber) {
                                                 setPageNumber(pageNumber + 1)
                                             } else {
                                                 setPageNumber(1)
                                             }
                                         }}><i className="td-icon icon-small td-icon-arrowRight2"></i>
            </a>}
        </>)
    }

    function ZoomInPDF() {
        return (<>
            <a onClick={() => {
                if (isMobile) {
                    zoomInRef.current.click()
                } else {
                    setDesktopScale(scale => scale * 1.1);
                }
            }}>
                <i className="bi bi-zoom-in"></i>
            </a>
        </>)
    }

    function ZoomOutPDF() {
        return (<>
            <a onClick={() => {
                if (isMobile) {
                    zoomOutRef.current.click()
                } else {
                    setDesktopScale(scale => scale / 1.1)
                }
            }}>
                <i className="bi bi-zoom-out"></i>
            </a>
        </>)
    }

    function downloadReportToFile() {
        let blob = new Blob([downloadReportData]);
        saveAs(blob, fileName);
    }

    const DownloadPDF = () => {
        return (<>
            <a onClick={downloadReportToFile} className="linkColor"><span
                className="td-icon icon-small td-icon-download"></span></a>
        </>)
    }

    function Pagination() {
        return (<>
            <Container style={{width: "100%", color: "white", padding: 0}} fluid>
                <Row style={{width: "100%", marginLeft: 0, marginRight: 0}}>

                    <Col xs={6}>
                        <Container style={{color: "white"}} fluid>
                            <Row style={{color: "white", padding: 0}}>
                                <Col xs={2} style={{padding: 0, alignSelf: "center"}}>
                                    <PagePREV/>
                                </Col>
                                {isMobile ? <Col style={{textAlign: "center"}}>
                                    {pageNumber}/{numPages}
                                </Col> : <Col xs={2} style={{textAlign: "center"}}>
                                    {pageNumber}/{numPages}
                                </Col>}
                                <Col xs={2} style={{padding: 0, alignSelf: "center"}}>
                                    <PageNext/>
                                </Col>
                            </Row>

                        </Container>
                    </Col>
                    <Col xs={6}>
                        <Container style={{color: "white"}} fluid>
                            <Row className={"flex-row-reverse"}>

                                <Col xs={1}>
                                    <DownloadPDF/>
                                </Col>

                                <Col xs={1}>
                                    <ZoomOutPDF/>
                                </Col>
                                <Col xs={1}>
                                    <ZoomInPDF/>
                                </Col>
                            </Row>

                        </Container>
                    </Col>
                </Row>
            </Container>
        </>)
    }

    const RenderPdfDocument = () => {
        return (<Document ref={documentRef}
                          file={`data:application/pdf;base64,${reportData}`}
                          onLoadSuccess={({numPages}) => setNumPages(numPages)}
                          onLoadError={console.error}
                          onRenderAnnotationLayerSuccess={console.log}
                          onRenderAnnotationLayerError={console.error}
                          onGetAnnotationsError={console.error}
            >

                <Page pageNumber={pageNumber} scale={desktopScale}/>
            </Document>)
    }

    return (<Container fluid style={{color: 'white', padding: 0}}>
        <Container fluid>
            <Row style={{paddingBottom: 0}}>
                <Col style={{
                    textAlign: "center",
                    alignSelf: "center",
                    background: "#32353a",
                    width: "100%",
                    margin: 0,
                    padding: 0,
                    color: "#fdfdfe"
                }} sm={12}>
                    <Pagination/>
                </Col>
            </Row>
        </Container>
        <Container fluid style={{padding: 0}}>
            {isMobile ? <TransformWrapper defaultScale={1} defaultPositionX={100}
                                          defaultPositionY={200}>
                {({zoomIn, zoomOut, ...rest}) => (<>
                                <span style={{display: "none"}}>
                                <a onClick={() => {
                                    zoomIn()
                                }} ref={zoomInRef}><i className="bi bi-zoom-in"></i></a>
                                <a onClick={() => {
                                    zoomOut()
                                }} ref={zoomOutRef}><i className="bi bi-zoom-out"></i></a>
                                </span>

                        <TransformComponent>
                            <RenderPdfDocument/>
                        </TransformComponent>
                    </>)}
            </TransformWrapper> : <div>
                <RenderPdfDocument/>
            </div>}
        </Container>
        <GridSpinner/>
    </Container>);
}
